import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from "react-localize-redux";
import FaQuestionCircle from "react-icons/lib/fa/question-circle";
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as actions from '../../actions';

import {formatNumber} from '../../utils/helpers';

/**
* Import components
*/

import SwitchButton from '../forms/SwitchButton';
import ImageContainer from '../image-handler/ImageContainer';
import ZargenSchurzenCode from '../ZargenSchurzenCode';

/**
* class StepOne
*/
class Step2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            switchButton: this.props.checked,
        };
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
    }

    handleSwitchChange(event) {
        this.setState({
            switchButton: !this.state.switchButton,
        })
    }

    /**
    * render method
    * @returns {XML}
    */
    render() {

        return (
            <div className="row step-content">
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('KRW.stepTwo.menu.title')}
                    </h5>
                    <div className='col s6 right-align'>
                        <FaQuestionCircle style={{fontSize: '20px'}}/>
                    </div>
                </div>
                <div className='row'>
                    <ZargenSchurzenCode
                        articleID={this.props.articleID}
                        article={this.props.article}
                        fieldCode='SIK'
                        inputName="KRW.SIK"
                        inputValue={this.props.krw.SIK.CurrentValue}
                        labelName={this.props.translate('KRW.stepTwo.form.title')}
                        className='custom-input-number__button--zargen'
                    />
                    <div className="row col s12">
                        <SwitchButton
                            articleID={this.props.articleID}
                            divClass={"row col s12 center-align"}
                            labelName={this.props.translate('KRW.stepTwo.form.back')}
                            labelPosition={'right'}
                            name={'KRW.SK23_switch'}
                            value={this.props.krw.SK23_switch.CurrentValue}
                            checked={this.props.krw.SK23_switch.CurrentValue}
                            onSwitchChange = {this.handleSwitchChange}
                        />
                    </div>


                </div>
                <div className="row valign-wrapper">
                    <div className="col s2">
                        <SwitchButton
                            articleID={this.props.articleID}
                            divClass="row col m9 xl10 offset-m3 offset-xl2 center-align"
                            labelName={this.props.translate('KRW.stepTwo.form.left')}
                            labelPosition={'right'}
                            name={'KRW.SK81_switch'}
                            value={this.props.krw.SK81_switch.CurrentValue}
                            checked={this.props.krw.SK81_switch.CurrentValue}
                            onSwitchChange = {this.handleSwitchChange}
                        />

                    </div>
                    <div className="row col s8">
                        <ImageContainer
                            image={this.props.image.Image}
                            name="krw"
                            divClass="col s12"
                            height="100%" />
                    </div>
                    <div className="col s2">
                        <SwitchButton
                            articleID={this.props.articleID}
                            divClass="row col m9 xl10 offset-m3 offset-xl4 center-align"
                            labelName={this.props.translate('KRW.stepTwo.form.right')}
                            labelPosition={'right'}
                            name={'KRW.SK45_switch'}
                            value={this.props.krw.SK45_switch.CurrentValue}
                            checked={this.props.krw.SK45_switch.CurrentValue}
                            onSwitchChange = {this.handleSwitchChange}
                        />

                    </div>
                </div>
                <div className="row col s12">
                    <SwitchButton
                        articleID={this.props.articleID}
                        divClass="row col s12 center-align"
                        labelName={this.props.translate('KRW.stepTwo.form.front')}
                        labelPosition={'right'}
                        name={'KRW.SK67_switch'}
                        value={this.props.krw.SK67_switch.CurrentValue}
                        checked={this.props.krw.SK67_switch.CurrentValue}
                        onSwitchChange = {this.handleSwitchChange}
                    />

                </div>

            </div>
        )
    }

}
Step2.propTypes = {
    lastStep:  PropTypes.number,
    translate: PropTypes.func,
    krw:   PropTypes.object,
}

function mapStateToProps({locale, krw, image}) {
return {
translate: getTranslate(locale),
krw,
image,
}
}

export default connect(mapStateToProps, actions)(Step2);




// WEBPACK FOOTER //
// ./src/components/krw-steps/Step2.js